'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["height"],
  _excluded2 = ["children", "className", "contentClassName"];
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import AbstractDeviceFrame from './AbstractDeviceFrame';
import { BATTLESHIP, GYPSUM } from 'HubStyleTokens/colors';
import { toPx } from '../utils/Styles';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEVICE_BORDER = BATTLESHIP;
const DesktopFrame = props => /*#__PURE__*/_jsxs("svg", Object.assign({}, props, {
  children: [/*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("path", {
      d: "M0 5.999A6 6 0 0 1 6.003 0h794.994A6 6 0 0 1 807 5.999V547a6 6 0 0 1-6.003 5.999H6.003A6 6 0 0 1 0 547.001V6z",
      id: "a"
    })
  }), /*#__PURE__*/_jsxs("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/_jsx("ellipse", {
      fill: DEVICE_BORDER,
      cx: "21",
      cy: "15.996",
      rx: "4",
      ry: "3.996"
    }), /*#__PURE__*/_jsx("ellipse", {
      fill: DEVICE_BORDER,
      cx: "34",
      cy: "15.996",
      rx: "4",
      ry: "3.996"
    }), /*#__PURE__*/_jsx("ellipse", {
      fill: DEVICE_BORDER,
      cx: "47",
      cy: "15.996",
      rx: "4",
      ry: "3.996"
    })]
  })]
}));
const DESKTOP_DEVICE_SPECS = {
  desktop: {
    Template: DesktopFrame,
    top: 32,
    right: 0,
    bottom: 0,
    left: 0,
    height: 555,
    width: 809
  }
};
const TITLEBAR_HEIGHT = DESKTOP_DEVICE_SPECS.desktop.top;
const COMPUTED_TOOLBAR_HEIGHT = `${TITLEBAR_HEIGHT / DESKTOP_DEVICE_SPECS.desktop.height * 100}%`;
const setToolbarHeight = height => {
  return height ? toPx(TITLEBAR_HEIGHT) : COMPUTED_TOOLBAR_HEIGHT;
};
const DesktopTemplate = styled(AbstractDeviceFrame.defaultProps.Template).withConfig({
  displayName: "UIDeviceFrameDesktop__DesktopTemplate",
  componentId: "sc-1rrdkjw-0"
})([""]);
const DesktopInner = styled(AbstractDeviceFrame.defaultProps.InnerWrapper).withConfig({
  displayName: "UIDeviceFrameDesktop__DesktopInner",
  componentId: "sc-1rrdkjw-1"
})([""]);
const DesktopWrapper = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(AbstractDeviceFrame.defaultProps.OuterWrapper, Object.assign({}, rest));
}).withConfig({
  displayName: "UIDeviceFrameDesktop__DesktopWrapper",
  componentId: "sc-1rrdkjw-2"
})(["border:1px solid ", ";border-radius:6px;", ";position:relative;", "{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;margin-top:", ";}", " &::before{background-color:", ";border-bottom:1px solid ", ";border-top-left-radius:inherit;border-top-right-radius:inherit;content:'';height:", ";left:0;position:absolute;top:0;width:100%;z-index:1;}"], DEVICE_BORDER, props => props.height && css(["height:", ";overflow:hidden;"], typeof props.height === 'number' ? toPx(props.height) : props.height), DesktopInner, props => props.height && toPx(TITLEBAR_HEIGHT), props => props.height && css(["", "{position:absolute;width:", ";}"], DesktopTemplate, toPx(DESKTOP_DEVICE_SPECS.desktop.width)), GYPSUM, DEVICE_BORDER, props => setToolbarHeight(props.height));
const DesktopContent = styled(props => {
  return /*#__PURE__*/_jsx(AbstractDeviceFrame.defaultProps.ContentWrapper, Object.assign({}, props));
}).withConfig({
  displayName: "UIDeviceFrameDesktop__DesktopContent",
  componentId: "sc-1rrdkjw-3"
})(["border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;"]);
const UIDeviceFrameDesktop = props => {
  const {
      children,
      className,
      contentClassName
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded2);
  return /*#__PURE__*/_jsx(AbstractDeviceFrame, Object.assign({}, rest, {
    className: classNames(className, 'UIDeviceFrameDesktop'),
    contentClassName: contentClassName,
    ContentWrapper: DesktopContent,
    InnerWrapper: DesktopInner,
    OuterWrapper: DesktopWrapper,
    spec: DESKTOP_DEVICE_SPECS.desktop,
    Template: DesktopTemplate,
    children: children
  }));
};
UIDeviceFrameDesktop.propTypes = {
  children: PropTypes.node.isRequired,
  contentClassName: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
UIDeviceFrameDesktop.displayName = 'UIDeviceFrameDesktop';
export default UIDeviceFrameDesktop;